import { render, staticRenderFns } from "./form-wtht.vue?vue&type=template&id=94b7e1b6&scoped=true&"
import script from "./form-wtht.vue?vue&type=script&lang=js&"
export * from "./form-wtht.vue?vue&type=script&lang=js&"
import style0 from "./form-wtht.vue?vue&type=style&index=0&id=94b7e1b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b7e1b6",
  null
  
)

export default component.exports